"use strict";

import { gsap } from "gsap";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";

import headerScrolling from "./scripts/headerScrolling";
import mobileMenu from "./scripts/mobileMenu";
import inputSelect from "./scripts/inputSelect";
import parallax from "./scripts/parallax";
import accordion from "./scripts/accordion";
import gsapAnimations from "./scripts/gsapAnimations";
import differentialsCascade from "./scripts/differencitalsCascade";
import sliderTestimonials from "./scripts/sliderTestimonials";
import initCountUp from "./scripts/countup";

window.gsap = gsap;

headerScrolling();
mobileMenu();
inputSelect();
parallax();
accordion();
gsapAnimations();
initCountUp();
differentialsCascade();
sliderTestimonials();
